module.exports = __webpack_public_path__ + "static/media/old india-avenue.103729ae.csv";